import { supabase } from './supabase'

/**
 * Registra un evento en audit_log.
 * Falla silenciosamente — nunca debe bloquear la operación principal.
 *
 * @param {object} params
 * @param {string} params.actorId   - usuario.id del usuario que ejecuta la acción
 * @param {string} params.actorRol  - rol del usuario
 * @param {string} params.accion    - 'envio.cancelar' | 'certificado.generar' | 'dj.submit' | etc.
 * @param {string} [params.tabla]   - tabla afectada
 * @param {string} [params.registroId] - id del registro afectado
 * @param {object} [params.detalle] - payload sin PII (no incluir RUT, nombre, datos bancarios)
 */
export async function auditLog({ actorId, actorRol, accion, tabla, registroId, detalle }) {
  try {
    await supabase.from('audit_log').insert({
      actor_id:    actorId,
      actor_rol:   actorRol,
      accion,
      tabla:       tabla       || null,
      registro_id: registroId  ? String(registroId) : null,
      detalle:     detalle     || null,
    })
  } catch (_) {
    // audit nunca interrumpe el flujo principal
  }
}
